/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {WinterHoardGameAssets} from "../WinterHoardGameAssets";

export class WinterHoardIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.79, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };

    stampConfig:StampConfig = {
        xWays:false,
        xNudge:false,
        volatility:Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    public static INTRO_BG = WinterHoardGameAssets.INTRO_BACKGROUND;
    public static INTRO_LOGO = WinterHoardGameAssets.INTRO_LOGO;
    public static INTRO_FEATURE_1 = "resources/images/Intro_Feature_1.png";
    public static INTRO_FEATURE_2 = "resources/images/Intro_Feature_2.png";
    public static INTRO_FEATURE_3 = "resources/images/Intro_Feature_3.png";
    public static INTRO_FEATURE_4 = "resources/images/Intro_Feature_4.png";
    public static INTRO_FEATURE_5 = "resources/images/Intro_Feature_5.png";
    public static INTRO_DIVIDER_TOP = "resources/images/BorderTop.png";
    public static INTRO_DIVIDER_BOTTOM = "resources/images/BorderBottom.png";
    //public static LAYOUT = "resources/images/image.png";

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("JONAS_BG",WinterHoardIntroConfig.INTRO_BG);
        imgLoader.add(WinterHoardIntroConfig.INTRO_LOGO,WinterHoardIntroConfig.INTRO_LOGO);
        imgLoader.add(WinterHoardIntroConfig.INTRO_FEATURE_1,WinterHoardIntroConfig.INTRO_FEATURE_1);
        imgLoader.add(WinterHoardIntroConfig.INTRO_FEATURE_2,WinterHoardIntroConfig.INTRO_FEATURE_2);
        imgLoader.add(WinterHoardIntroConfig.INTRO_FEATURE_3,WinterHoardIntroConfig.INTRO_FEATURE_3);
        imgLoader.add(WinterHoardIntroConfig.INTRO_FEATURE_4,WinterHoardIntroConfig.INTRO_FEATURE_4);
        imgLoader.add(WinterHoardIntroConfig.INTRO_FEATURE_5,WinterHoardIntroConfig.INTRO_FEATURE_5);
        imgLoader.add(WinterHoardIntroConfig.INTRO_DIVIDER_BOTTOM,WinterHoardIntroConfig.INTRO_DIVIDER_BOTTOM);
        imgLoader.add(WinterHoardIntroConfig.INTRO_DIVIDER_TOP,WinterHoardIntroConfig.INTRO_DIVIDER_TOP);
        //imgLoader.add(WinterHoardIntroConfig.LAYOUT,WinterHoardIntroConfig.LAYOUT);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("JONAS_BG"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_DIVIDER_TOP));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_DIVIDER_BOTTOM));
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_LOGO));
        logoSprite.anchor.set(0.5, 0.55);
        this.logo.addChild(logoSprite);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_FEATURE_1), SlotGame.api.translations.translate("Collect the energy to turn all animals into the mighty Buffalo.")),
            new SlideShowPage(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_FEATURE_2), SlotGame.api.translations.translate("Collect the energy to award a win multiplier on all animal symbols."), undefined, false),
            new SlideShowPage(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_FEATURE_3), SlotGame.api.translations.translate("Awards both an increased multiplier and turn all animals into the mighty Buffalo!"),undefined, false),
            new SlideShowPage(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_FEATURE_4), SlotGame.api.translations.translate("A Wild symbol substitutes for any symbol except Scatter.")),
            new SlideShowPage(ImgLoader.getImgTexture(WinterHoardIntroConfig.INTRO_FEATURE_5), SlotGame.api.translations.translate("Mystery symbol reveals one of the paying symbols."), )
        ];
    }
}
